import styled from '@emotion/styled';
import { CalloutInline, Link } from '@modernhealth/vital-components';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const AutopayCallout: React.FC = () => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(true);
    const onDismiss = () => setVisible(false);

    return (
        <>
            {visible && (
                <CalloutContainer>
                    <CalloutInline
                        variant="default"
                        heading={t('payments:autopay_callout.heading')}
                        onDismiss={onDismiss}
                    >
                        <ContentContainer>
                            {t('payments:autopay_callout.body')}
                            <Link>
                                <a
                                    href={process.env.REACT_APP_INSTAMED_IFRAME_PAYMENT_PORTAL_URL}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    {t('payments:autopay_callout.action')}
                                </a>
                            </Link>
                        </ContentContainer>
                    </CalloutInline>
                </CalloutContainer>
            )}
        </>
    );
};

const CalloutContainer = styled.div({
    marginBottom: '20px',
});

const ContentContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
});
